"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TYPESENSE_QUERY_BY_FOR_PART_LIBRARY = exports.TYPESENSE_QUERY_BY_FOR_PROFILE = exports.QDRANT_PARTS_EMBEDDING_MODEL = exports.QDRANT_PARTS_COLLECTION_NAME = exports.TYPESENSE_PARTS_VECTORIZED_COLLECTION_NAME = exports.TYPESENSE_PARTS_COLLECTION_NAME = exports.TYPESENSE_ORGANIZATIONS_COLLECTION_NAME = exports.TYPESENSE_USER_EMAILS_COLLECTION_NAME = exports.TYPESENSE_USERS_COLLECTION_NAME = exports.TYPESENSE_PROJECTS_COLLECTION_NAME = void 0;
// Typesense
exports.TYPESENSE_PROJECTS_COLLECTION_NAME = "projects";
exports.TYPESENSE_USERS_COLLECTION_NAME = "users";
exports.TYPESENSE_USER_EMAILS_COLLECTION_NAME = "userEmails";
exports.TYPESENSE_ORGANIZATIONS_COLLECTION_NAME = "organizations";
exports.TYPESENSE_PARTS_COLLECTION_NAME = "parts";
exports.TYPESENSE_PARTS_VECTORIZED_COLLECTION_NAME = "parts-vectorized";
exports.QDRANT_PARTS_COLLECTION_NAME = "parts";
exports.QDRANT_PARTS_EMBEDDING_MODEL = "text-embedding-3-small";
// `query_by` parameter we send to Typesense when searching for documents
// in profile page
exports.TYPESENSE_QUERY_BY_FOR_PROFILE = "name,description,slug";
// This is equivalent to `searchableAttributes` configured in `ALGOLIA_PART_SEARCH_INDEX_SETTINGS`
exports.TYPESENSE_QUERY_BY_FOR_PART_LIBRARY = "name,nameSuffixes,description,properties.value,properties.unit,owner_name,owner_handle,part_type";
//# sourceMappingURL=search.js.map